import { MenuTreeNodeType } from '@redux/types'
import { I18n, I18nType } from '@schemas'

class MenuTreeNode implements MenuTreeNodeType {
	constructor({
		id = '',
		text = '',
		order = 0,
		icon = '',
		path = '',
		uri = '',
		parent = '',
		droppable = false,
		isActivate = false,
		i18n = [],
	} = {}) {
		this.id = id === null ? '' : id
		this.text = text === null ? '' : text
		this.order = order === null ? 0 : order
		this.icon = icon === null ? '' : icon
		this.path = path === null ? '' : path
		this.uri = uri === null ? '' : uri
		this.parent = parent === null ? '' : parent
		this.droppable = droppable ?? false
		this.isActivate = isActivate ?? false
		this.i18n = i18n === null ? [] : (i18n.map(anI18n => new I18n(anI18n)) as I18nType[])
	}

	id: string
	text: string
	order: number
	icon: string
	path: string
	uri: string
	parent: string
	droppable?: boolean
	isActivate?: boolean
	i18n: I18nType[]
}

export { MenuTreeNode }
